<template>
  <component :is="onboardingComponent"/>
</template>

<script>
import * as FullStory from '@fullstory/browser';
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import consts from '../../../../constants/onboarding-state';
import BotiIntro from './steps/BotiIntro.vue';
import BankSelectionFlow from './steps/bank-selection/BankSelectionFlow.vue';
import AccountInvestigationOnboarding from './steps/account-investigation/AccountInvestigationOnboarding.vue';
import IncomeInvestigationOnboarding from './steps/income-investigation/IncomeInvestigationOnboarding.vue';
import CreditCardConnectionFlow from './steps/credit-card-connection/CreditCardConnectionFlow.vue';
import ExpenseInvestigationOnboarding from './steps/expense-investigation/ExpenseInvestigationOnboarding.vue';
import ProgressIndication1 from './steps/ProgressIndication1.vue';
import ProgressIndication2 from './steps/ProgressIndication2.vue';
import SecurityInformation from './steps/SecurityInformation.vue';
import CashflowLoader from './steps/cashflow-loader/CashflowLoader.vue';
import config from '../../../../config';


export default {
  name: 'OnboardFlow',
  async created() {
    await this.fetchOnboardingState();
    if (!this.pageName) {
      await this.getNextPage();
    }
    await FullStory.init({ orgId: config.get().fullStoryOrgId, devMode: process.env.NODE_ENV !== 'production' });
    Vue.prototype.$FullStory = FullStory;
    setTimeout(() => this.identify(), 3000);
  },

  async beforeDestroy() {
    FullStory.shutdown();
  },
  computed: {
    ...mapState('session', ['customerId']),
    ...mapState('onboardingState', ['pageName', 'isLoading', 'error', 'pageParams']),
    ...mapState('websocket', ['socketMessage']),
    pageToComponent() {
      return {
        [consts.ONBOARDING_PAGE.BOTI_INTRO]: BotiIntro,
        [consts.ONBOARDING_PAGE.CASHFLOW_LOADER]: CashflowLoader,
        [consts.ONBOARDING_PAGE.PROGRESS_INDICATION_1]: ProgressIndication1,
        [consts.ONBOARDING_PAGE.PROGRESS_INDICATION_2]: ProgressIndication2,
        [consts.ONBOARDING_PAGE.SECURITY_INFORMATION]: SecurityInformation,
        [consts.ONBOARDING_PAGE.BANK_SELECTION]: BankSelectionFlow,
        [consts.ONBOARDING_PAGE.ACCOUNT_INVESTIGATION]: AccountInvestigationOnboarding,
        [consts.ONBOARDING_PAGE.INCOME_INVESTIGATION]: IncomeInvestigationOnboarding,
        [consts.ONBOARDING_PAGE.CREDIT_CARD_DETAILS]: CreditCardConnectionFlow,
        [consts.ONBOARDING_PAGE.EXPENSE_INVESTIGATION]: ExpenseInvestigationOnboarding,
      };
    },
    onboardingComponent() {
      return this.pageToComponent[this.pageName];
    },
    getComponentProps() {
      return this.pageParams || {};
    },
  },
  methods: {
    ...mapActions('onboardingState', ['fetchOnboardingState', 'getNextPage']),
    identify() {
      FullStory.identify(this.customerId);
    },
  },
  watch: {
    async socketMessage(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (this.isLoading) {
          await this.fetchOnboardingState();
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard2/OnboardFlow.vue